import styled from "styled-components";
import { Device } from "../../../components/device";

export const CalendarWrap = styled.div`
    position: relative;
    color: black;

    .tooltip__i {
        background-color: var(--color-gray-20, gray);
        color: var(--color-gray-60, black);
        transition: all .3s;
        &:hover {
            background-color: var(--color-gray-60, black);
            color: var(--color-white, white);
        }
    }
`;

export const CalendarDayWrap = styled.div`
    border-bottom: 2px solid currentColor;
    display: flex;
    padding-top: 1rem;
    padding-bottom: 1rem;
    line-height: 1.125;

    .calendar__date {
        width: 25%;
        display: flex;
        flex-wrap: wrap;
        flex-flow: row;
        padding-top: 22px;

        ${Device.tablet} {
            width: 15%;
        }
    }

    .calendar__events {
        width: 75%;
        list-style: none;
        margin: 0;
        padding: 0 0 0 0.5rem;
        ${Device.tablet} {
            padding-left: 1rem;
            width: 85%;
        }
    }

    .calendar__day-number {
        font-size: var(--text-4xl);
        line-height: var(--leading-none, 1);
        letter-spacing: -0.025em;
        margin-bottom: 0;
        position: relative;
        top: -2px;

        ${Device.desktop} {
            font-size: var(--text-5xl);
            top: 0px;
        }

        ${Device.desktopLG} {
            font-size: var(--text-6xl);
        }
    }

    .calendar__day-month {
        padding-left: 3px;

        ${Device.tablet} {
            padding-top: 0;
        }
    }

    .calendar__date-month {
        display: block;
        font-weight: bold; 
        line-height: 1.25;
        text-transform: uppercase;
    }

    .calendar__day-name {
        font-size: 13px;
        opacity: 0.5;
        text-transform: capitalize;
        font-weight: normal;

        ${Device.desktop} {
            font-size: 15px;
        }
    }
`;

export const CalendarMonthWrap = styled.div`
    font-family: var(--font-josefin-sans, 'Josefin Sans', sans-serif);
    font-size: var(--text-sm, .875rem);
    font-weight: bold;
    margin-bottom: 1rem;
    text-transform: uppercase;

    .calendar-month-sticky {
        background-color: var(--color-white, white);
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 40;
    }

    .calendar-month-header {
        align-items: center;
        background-color: var(--color-white, white);
        border-bottom: 2px solid currentColor;
        display: flex;
        font-weight: bold;
        margin-bottom: 0;
        padding-top: 1rem;
        padding-bottom: 1rem;
        justify-content: space-between;
    }

    .calendar-month-button {
        display: none;
        > a {
            margin: 0;
            min-width: 0;
        }
    }
`;